
export class AngularReduxDataServiceConfig {
    entityNameSpaces: string[];
    entityAdapterMappings: any;
    defaultHost: string;
    defaultPath: string;
    customReducers: any;
    effects: any[];
}
